module.exports = __webpack_public_path__ + "img/sasearc.dcf385ce.jpg";